// 「お知らせ」周りはLP、サービスどちらでも変わらず使用するため、pluginで一番最初に取得
export default ({ store }) => {
    store.dispatch('initServiceNotifications');
};
